/**
 * Attachment mime helpers (WordPress REST / post_mime_type).
 */
export function isVideoMime(mime) {
  return Boolean(mime && String(mime).toLowerCase().startsWith('video/'))
}

export function isImageMime(mime) {
  return !mime || String(mime).toLowerCase().startsWith('image/')
}

/**
 * WordPress REST error body: { code, message: string|array|object, data }
 */
export function parseRestErrorMessage(data, fallback) {
  if (!data || typeof data !== 'object') {
    return fallback
  }
  const m = data.message
  if (typeof m === 'string' && m) {
    return data.code && typeof data.code === 'string' && !m.includes(String(data.code))
      ? `${m} (${data.code})`
      : m
  }
  if (Array.isArray(m) && m[0] && m[0].message) {
    return String(m[0].message)
  }
  if (m && typeof m === 'object' && m.message) {
    return String(m.message)
  }
  if (typeof data.code === 'string' && data.code) {
    return data.code
  }
  return fallback
}
